module.exports = __webpack_public_path__ + "static/media/monitor.38dd151a.svg";